const marketOrTrackList = [
  {
    group: "Market",
    sub_list: [
      "ATCI",
      "EMEA",
      "GM",
      "ATC Global Network",
      "ATCI Song",
      "Cloud",
      "AI",
      "E&IT",
      "I&D",
      "Delivery",
      "BI&HS",
      "Language & Culture Academy",
      "L&TT",
      "LIS",
      "L&TT Ops",
      "LDE NeXT",
    ],
  },
  {
    group: "6 specialized Practices",
    sub_list: [
      "Enterprise Platforms",
      "Cloud First",
      "Data & AI",
      "Security",
      "Infrastructure Engineering",
      "Software & Platform Engineering",
    ],
  },
  {
    group: "5 Technology Industry Practices",
    sub_list: [
      "Communications/Media/Technology",
      "Financial Services",
      "Health/Public Service",
      "Products",
      "Resources",
    ],
  },
];

export default marketOrTrackList;
